
export default {
  props: {
    arrs: {
      type: Array,
      default: () => [],
    },

    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bannerUrl:
        "background: no-repeat 50%/cover url(" +
        this.$myPlugin.imgOssUrl +
        "juude_success_banner.png" +
        ")",
    };
  },
  methods: {},
};
